import { Users } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import AppLayout from '@/components/AppLayout';

export default function ContactsPage() {
  return (
    <AppLayout>
      <div className="p-8" data-testid="contacts-page">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-ink font-display tracking-tight">Contacts</h1>
          <p className="mt-1 text-muted-brand">Manage your property-related contacts</p>
        </div>

        <Card className="border-line">
          <CardContent className="flex flex-col items-center justify-center py-16">
            <Users className="w-16 h-16 text-line mb-4" />
            <h3 className="text-lg font-semibold text-ink font-display">
              Contacts coming soon
            </h3>
            <p className="text-sm text-muted-brand mt-1 text-center max-w-md">
              Store and manage contacts for tenants, contractors, letting agents, and other property-related contacts. This feature is currently under development.
            </p>
          </CardContent>
        </Card>
      </div>
    </AppLayout>
  );
}
